/**
 * Function iterates through all the properties of an object and replaces all the null values with empty strings
 * @param input can be object of any type with nested object structure. Type can be specified by generics
 */
export const replaceNullWithEmptyString = <T>(input: T): T => {
  const keys = Object.keys(<any>input);
  keys.forEach((property: any) => {
    if (property instanceof Object) {
      (<any>input)[property] = replaceNullWithEmptyString(property);
    } else if ((<any>input)[property] === null) {
      (<any>input)[property] = '';
    }
  });
  return input;
};
